import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isHome ? 'bg-foreground-950' : 'bg-foreground-950'
      }`}
    >
      {/* Breaking news ticker */}
      <div className="bg-accent-500 text-background-50 text-xs py-1.5 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap flex">
          <span className="inline-block px-4 flex-shrink-0">
            🔥 某顶流男星深夜密会神秘女子，酒店共度8小时 &nbsp;&nbsp;|&nbsp;&nbsp;
            🔥 千万粉丝网红直播翻车，假货风波持续发酵 &nbsp;&nbsp;|&nbsp;&nbsp;
            🔥 娱乐圈大佬被曝性骚扰多名女艺人 &nbsp;&nbsp;|&nbsp;&nbsp;
            🔥 网红圈爆出惊天大瓜，多位头部主播涉嫌税务问题
          </span>
          <span className="inline-block px-4 flex-shrink-0">
            🔥 某顶流男星深夜密会神秘女子，酒店共度8小时 &nbsp;&nbsp;|&nbsp;&nbsp;
            🔥 千万粉丝网红直播翻车，假货风波持续发酵 &nbsp;&nbsp;|&nbsp;&nbsp;
            🔥 娱乐圈大佬被曝性骚扰多名女艺人 &nbsp;&nbsp;|&nbsp;&nbsp;
            🔥 网红圈爆出惊天大瓜，多位头部主播涉嫌税务问题
          </span>
        </div>
      </div>

      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-14 max-w-7xl mx-auto">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="text-accent-500 font-bold text-xl md:text-2xl tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
              今日黑料
            </span>
            <span className="hidden sm:inline text-background-50/40 text-xs border border-background-50/20 rounded px-1.5 py-0.5">
              爆料汇总
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                  location.pathname === link.to
                    ? 'text-accent-500 bg-accent-500/10'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </Link>
            ))}

            {/* Category dropdown */}
            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'text-accent-500 bg-accent-500/10'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <>
                  <div className="fixed inset-0 z-40" onClick={() => setCategoryOpen(false)}></div>
                  <div className="absolute top-full left-0 mt-1 w-48 bg-background-50 rounded-lg border border-background-200 shadow-lg z-50 py-1">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        onClick={() => setCategoryOpen(false)}
                        className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-800 hover:bg-background-100 hover:text-accent-500 transition-colors whitespace-nowrap"
                      >
                        <i className={`${cat.icon} text-accent-500`}></i>
                        {cat.name}
                        <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div>
          </nav>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-background-50"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden border-t border-background-50/10 pb-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3 text-sm ${
                  location.pathname === link.to
                    ? 'text-accent-500 bg-accent-500/10'
                    : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-4 pt-2 text-xs text-background-50/40 uppercase tracking-wider">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-2 px-4 py-3 text-sm text-background-50/80 hover:text-accent-500"
              >
                <i className={`${cat.icon} text-accent-500`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}